import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";

const roleDataSlice = createSlice({
  name: "roleDataSlice",
  initialState: {
    isLoading: false,
    submitReport: [],
    rolesData: [],
    rolesDataDropdown: [],
    permissionData: [],
    rolePermissionIds: [],
    reportingData: [],
    reportingData2: [],
    singleRoleData: null,
  },
  reducers: {
    startAddRole(state) {
      state.isLoading = true;
    },
    startUpdateRole(state) {
      state.isLoading = true;
    },
    startDeleteRole(state) {
      state.isLoading = true;
    },
    roleSuccess(state) {
      state.isLoading = false;
    },
    roleError(state) {
      state.isLoading = false;
    },
    startRolesData(state, action) {
      state.isLoading = true;
    },
    setRolesData(state, action) {
      state.rolesData = action.payload;
    },
    startRolesDataDropdown(state, action) {
      state.isLoading = true;
    },
    setRolesDataDropdown(state, action) {
      state.rolesDataDropdown = action.payload
    },
    startFetchSingleRole(state, action) {
      state.isLoading = true;
    },
    setSingleRoleData(state, action) {
      state.singleRoleData = action.payload;
    },
    clearSingleRoleData(state, action) {
      state.singleRoleData = null;
    },
    completedFetch(state, action) {
      state.isLoading = false;
    },
    fetchPermissionData(state, action) {
      state.isLoading = true;
    },
    setPermissionData(state, action) {
      state.permissionData = action.payload;
    },
    fetchRolePermissionIds(state, action) {
      state.isLoading = true;
    },
    setRolePermissionIds(state, action) {
      state.rolePermissionIds = action.payload;
    },
    updateRolePermissions(state) {
      state.isLoading = true;
    },
    updateRolePermissionsSuccess(state) {
      state.isLoading = false;
    },
    updateRolePermissionsError(state) {
      state.isLoading = false;
    },
    startReportingData(state, action) {
      state.isLoading = true;
    },
    setReportingData(state, action) {
      state.reportingData = action.payload;
    },
    startReportingData2(state, action){
      state.isLoading = true;
    },
    setReportingData2(state, action) {
      state.reportingData2 = action.payload;
    },
    submitReport(state, action){
      state.isLoading = true;
    },
    setReport(state, action){
      state.submitReport = action.payload
    }
  },
});

export const {
  startRolesData,
  setRolesData,
  startRolesDataDropdown,
  setRolesDataDropdown,
  startFetchSingleRole,
  setSingleRoleData,
  clearSingleRoleData,
  startAddRole,
  startUpdateRole,
  startDeleteRole,
  roleSuccess,
  roleError,
  completedFetch,
  fetchPermissionData,
  setPermissionData,
  fetchRolePermissionIds,
  setRolePermissionIds,
  updateRolePermissions,
  updateRolePermissionsSuccess,
  updateRolePermissionsError,
  startReportingData,
  setReportingData,
  startReportingData2,
  setReportingData2,
  submitReport,
  setReport
} = roleDataSlice.actions;

export default roleDataSlice.reducer;

/////Selectors
const mainRoleDataState = (state) => state.RoleData;

export const reportingDataSelector = createSelector([mainRoleDataState], (roleState)=> roleState.reportingData);
export const reportingDataSelector2 = createSelector([mainRoleDataState], (roleState)=> roleState.reportingData2);

export const isLoadingSelector = createSelector([mainRoleDataState],(roleState) => roleState.isLoading);

export const permissionDataSelector = createSelector(
  [mainRoleDataState],
  (permission) => permission.permissionData || []
)

export const rolesDataSelector = createSelector(
  [mainRoleDataState],
  (roleState) => roleState.rolesData || []
);

export const rolesDataDropDownSelector = createSelector(
  [mainRoleDataState],
  (roleState) => roleState.rolesDataDropdown || []
);

export const singleRoleDataSelector = createSelector(
  [mainRoleDataState],
  (roleState) => roleState.singleRoleData
);

export const rolePermissionIdsSelector = createSelector(
  [mainRoleDataState],
  (s) => s.rolePermissionIds
);

